export const statsPerTemplate = {
  playerCompare: {
    striker: [
      {
        title: "Tore",
        key: "goals",
      },
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
      },
      {
        title: "Assists",
        key: "goalAssist",
      },
      {
        title: "Torschussvorlagen",
        key: "totalAttAssist",
      },
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
    ],
    midfielder: [
      {
        title: "Tore",
        key: "goals",
      },
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
      },
      {
        title: "Assists",
        key: "goalAssist",
      },
      {
        title: "Torschussvorlagen",
        key: "totalAttAssist",
      },
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
    ],
    defender: [
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Präzise Pässe",
        key: "accuratePass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Zweikämpfe",
        key: "calcTotalDuels",
        deps: ["duelLost", "duelWon"],
        calc: "##duelLost##+##duelWon##",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
      {
        title: "gew. Zweikämpfe",
        key: "duelWon",
      },
      {
        title: "Fouls",
        key: "fouls",
      },
    ],
    goalkeeper: [
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Paraden",
        key: "saves",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Gegentore",
        key: "goalsConceded",
      },
      {
        title: "Spielminuten",
        key: "minsPlayed",
      },
      {
        title: "Fouls",
        key: "fouls",
      },
    ],
  },
  playerCompareSeason: {
    midfielder: [
      {
        title: "Spiele",
        key: "Games Played",
      },
      {
        title: "Tore",
        key: "Goals",
      },
      {
        title: "Torschüsse",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Assists",
        key: "Goal Assists",
      },
      {
        title: "Torschussvorlagen",
        key: "Key Passes (Attempt Assists)",
      },
      {
        title: "Ballaktionen",
        key: "Touches",
      },
      {
        title: "Pässe gesamt",
        key: "Total Passes",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: [
          "Total Successful Passes ( Excl Crosses & Corners ) ",
          "Total Passes",
        ],
        calc: "##Total Successful Passes ( Excl Crosses & Corners ) ##/(##Total Passes##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["Duels lost", "Duels won"],
        calc: "##Duels won##/((##Duels lost##+##Duels won##)/100)",
      },
    ],
    forward: [
      {
        title: "Spiele",
        key: "Games Played",
      },
      {
        title: "Tore",
        key: "Goals",
      },
      {
        title: "Torschüsse",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Assists",
        key: "Goal Assists",
      },
      {
        title: "Torschussvorlagen",
        key: "Key Passes (Attempt Assists)",
      },
      {
        title: "Ballaktionen",
        key: "Touches",
      },
      {
        title: "Pässe gesamt",
        key: "Total Passes",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: [
          "Total Successful Passes ( Excl Crosses & Corners ) ",
          "Total Passes",
        ],
        calc: "##Total Successful Passes ( Excl Crosses & Corners ) ##/(##Total Passes##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["Duels lost", "Duels won"],
        calc: "##Duels won##/((##Duels lost##+##Duels won##)/100)",
      },
    ],
  },
  teamCompare: {
    offensive: [
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
      },
      {
        title: "Schüsse aufs Tor",
        key: "ontargetScoringAtt",
      },
      {
        title: "Big Chances",
        key: "bigChanceCreated",
      },
      {
        title: "Chancenverwertung in %",
        key: "calcChancesCreated",
        deps: ["goals", "totalScoringAtt"],
        calc: "(##goals##/##totalScoringAtt##)*100",
      },
      {
        title: "Ecken",
        key: "cornerTaken",
      },
      {
        title: "Erfolgreiche Dribblings in %",
        key: "calcSuccessContest",
        deps: ["wonContest", "totalContest"],
        calc: "(##wonContest##/##totalContest##)*100",
      },
    ],
    defensive: [
      {
        title: "Ballbesitz in %",
        key: "possessionPercentage",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Anzahl Zweikämpfe",
        key: "calcZweikampfAnzahl",
        deps: ["duelLost", "duelWon"],
        calc: "##duelLost##+##duelWon##",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
      {
        title: "Fouls",
        key: "fkFoulLost",
      },
    ],
  },
  teamCompareSeason: {
    offensive: [
      {
        title: "Tore",
        key: "Goals",
      },
      {
        title: "Torschüsse",
        key: "calcTotalShotsAndBlocked",
        deps: ["Total Shots", "Blocked Shots"],
        calc: "##Total Shots##+##Blocked Shots##",
      },
      {
        title: "Schüsse aufs Tor",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Shooting Accuracy",
        key: "Shooting Accuracy"
      },
      {
        title: "Torschüsse",
        key: "chanceConversion",
        deps: ["Total Shots", "Blocked Shots", "Goals"],
        calc: "##Goals##/(##Total Shots##+##Blocked Shots##)*100",
      },
      {
        title: "Shots within the box",
        key: "Shots within the box"
      },
    ],
    defensive: [
      {
        title: "Zweikampfquote in %",
        key: "zweikampf", // Duels
        deps: ["Duels"],
        calc: "(##Duels##)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["Duels lost", "Duels won"],
        calc: "##Duels won##/((##Duels lost##+##Duels won##)/100)",
      },
      {
        title: "total tackle pct",
        key: "total tackle pct",
      },
      {
        title: "Passquote in %",
        key: "total passes",
        deps: ["Total Passes"],
        calc: "(##Total Passes##)",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: [
          "Total Successful Passes ( Excl Crosses & Corners ) ",
          "Total Passes",
        ],
        calc: "##Total Successful Passes ( Excl Crosses & Corners ) ##/(##Total Passes##/100)",
      },
      {
        title: "total fouls",
        key: "total fouls",
      },
    ],
  },
  teamGoalmouth: [
    {
      title: "Schüsse",
      key: "totalScoringAtt",
    },
    {
      title: "Torschüsse",
      key: "ontargetScoringAtt",
    },
    {
      title: "Tore",
      key: "goals",
    },
    {
      title: "Paraden %",
      key: "calcParaden",
      deps: ["ontargetScoringAtt", "#VERSUS#ontargetScoringAtt", "goalsConceded", "#VERSUS#goalsConceded"],
      // calc: "(#VERSUS#ontargetScoringAtt##-##goalsConceded##)/(#VERSUS#ontargetScoringAtt##)*100",
      calc: "(##ontargetScoringAtt##-#VERSUS#goalsConceded##)/(##ontargetScoringAtt##)*100",
      // calc: "#VERSUS#saves##/((##ontargetScoringAtt##)/100)",
    },
  ],
  ofTeamGoalmouth: [
    {
      title: "Schüsse",
      key: "totalScoringAtt",
    },
    {
      title: "Tore",
      key: "goals",
    },
    {
      title: "Paraden %",
      key: "calcParaden",
      deps: ["#VERSUS#saves", "ontargetScoringAtt"],
      calc: "#VERSUS#saves##/((##ontargetScoringAtt##)/100)",
    },
  ],
  playerHeatmap: [
    {
      title: "Ballaktionen",
      key: "touches",
    },
    {
      title: "Passquote in %",
      key: "calcPassquote",
      deps: ["accuratePass", "totalPass"],
      calc: "##accuratePass##/(##totalPass##/100)",
    },
    {
      title: "Pässe gesamt",
      key: "totalPass",
    },
  ],
};


export const statsPerTemplateSD = {
  playerCompare: {
    striker: [
      {
        title: "Tore",
        key: "goals",
        sdKey: "ShotsAtGoalSuccessfull"
      },
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
        sdKey: "ShotsAtGoalSum"
      },
      {
        title: "Torschussvorlagen",
        key: "totalAttAssist",
        sdKey: "Chances"
      },
      {
        title: "Chancenverwertung in %",
        key: "calcChancesCreated",
        deps: ["ShotsAtGoalSuccessfull", "ShotsAtGoalSum"],
        calc: "(##ShotsAtGoalSuccessfull##/##ShotsAtGoalSum##)*100",
      },
      {
        title: "Assists",
        key: "goalAssist",
        sdKey: "Assists"
      },
      // {
      //   title: "Ballaktionen",
      //   key: "touches",
      //   sdKey: "BallActions"
      // },
      // {
      //   title: "Pässe gesamt",
      //   key: "totalPass",
      //   sdKey: "PassesSum"
      // },
      // {
      //   title: "Passquote in %",
      //   key: "calcPassquote",
      //   deps: ["PassesSuccessfulSum", "PassesSum"],
      //   calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      // },
      // {
      //   title: "Zweikampfquote in %",
      //   key: "calcZweikampfquote",
      //   deps: ["TacklingGamesWon", "TacklingGamesSum"],
      //   calc: "##TacklingGamesWon##/((##TacklingGamesSum##)/100)",
      // },
    ],
    midfielder: [
      {
        title: "Tore",
        key: "goals",
        sdKey: "ShotsAtGoalSuccessfull"
      },
      {
        title: "Assists",
        key: "goalAssist",
        sdKey: "Assists"
      },
      // {
      //   title: "Torschüsse",
      //   key: "totalScoringAtt",
      //   sdKey: "ShotsAtGoalSum"
      // },
      // {
      //   title: "Torschussvorlagen",
      //   key: "totalAttAssist",
      //   sdKey: "Chances"
      // },
      {
        title: "Ballaktionen",
        key: "touches",
        sdKey: "BallActions"
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
        sdKey: "PassesSum"
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["PassesSuccessfulSum", "PassesSum"],
        calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      },
      // {
      //   title: "Zweikampfquote in %",
      //   key: "calcZweikampfquote",
      //   deps: ["TacklingGamesWon", "TacklingGamesSum"],
      //   calc: "##TacklingGamesWon##/((##TacklingGamesSum##)/100)",
      // },
    ],
    defender: [
      // {
      //   title: "Ballaktionen",
      //   key: "touches",
      //   sdKey: "BallActions"
      // },
      // {
      //   title: "Zweikämpfe",
      //   key: "calcTotalDuels",
      //   deps: ["TacklingGamesLost", "TacklingGamesWon"],
      //   calc: "##TacklingGamesLost##+##TacklingGamesWon##",
      // },
      {
        title: "gew. Zweikämpfe",
        key: "duelWon",
        sdKey: "TacklingGamesWon"
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["TacklingGamesWon", "TacklingGamesSum"],
        calc: "##TacklingGamesWon##/((##TacklingGamesSum##)/100)",
      },
      {
        title: "Fouls",
        key: "fouls",
        sdKey: "FoulsSum"
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
        sdKey: "PassesSum"
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["PassesSuccessfulSum", "PassesSum"],
        calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      },
    ],
    goalkeeper: [
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Paraden",
        key: "saves",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Gegentore",
        key: "goalsConceded",
      },
      {
        title: "Spielminuten",
        key: "minsPlayed",
      },
      {
        title: "Fouls",
        key: "fouls",
      },
    ],
  },
  mvp: {
    striker: [
      {
        title: "Tore",
        key: "goals",
        sdKey: "ShotsAtGoalSuccessfull"
      },
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
        sdKey: "ShotsAtGoalSum"
      },
      {
        title: "Assists",
        key: "goalAssist",
        sdKey: "Assists"
      },
      {
        title: "Torschussvorlagen",
        key: "totalAttAssist",
        sdKey: "Chances"
      },
      {
        title: "Ballaktionen",
        key: "touches",
        sdKey: "BallActions"
      },
      // {
      //   title: "Pässe gesamt",
      //   key: "totalPass",
      //   sdKey: "PassesSum"
      // },
      // {
      //   title: "Passquote in %",
      //   key: "calcPassquote",
      //   deps: ["PassesSuccessfulSum", "PassesSum"],
      //   calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      // },
      // {
      //   title: "Zweikampfquote in %",
      //   key: "calcZweikampfquote",
      //   deps: ["TacklingGamesWon", "TacklingGamesSum"],
      //   calc: "##TacklingGamesWon##/((##TacklingGamesSum##)/100)",
      // },
    ],
    midfielder: [
      {
        title: "Tore",
        key: "goals",
        sdKey: "ShotsAtGoalSuccessfull"
      },
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
        sdKey: "ShotsAtGoalSum"
      },
      {
        title: "Assists",
        key: "goalAssist",
        sdKey: "Assists"
      },
      {
        title: "Torschussvorlagen",
        key: "totalAttAssist",
        sdKey: "Chances"
      },
      {
        title: "Ballaktionen",
        key: "touches",
        sdKey: "BallActions"
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
        sdKey: "PassesSum"
      },
      // {
      //   title: "Passquote in %",
      //   key: "calcPassquote",
      //   deps: ["PassesSuccessfulSum", "PassesSum"],
      //   calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      // },
      // {
      //   title: "Zweikampfquote in %",
      //   key: "calcZweikampfquote",
      //   deps: ["TacklingGamesWon", "TacklingGamesSum"],
      //   calc: "##TacklingGamesWon##/((##TacklingGamesSum##)/100)",
      // },
    ],
    defender: [
      {
        title: "Pässe gesamt",
        key: "totalPass",
        sdKey: "PassesSum"
      },
      {
        title: "Präzise Pässe",
        key: "accuratePass",
        sdKey: "PassesSuccessfulSum"
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["PassesSuccessfulSum", "PassesSum"],
        calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      },
      {
        title: "Ballaktionen",
        key: "touches",
        sdKey: "BallActions"
      },
      {
        title: "Zweikämpfe",
        key: "calcTotalDuels",
        deps: ["TacklingGamesLost", "TacklingGamesWon"],
        calc: "##TacklingGamesLost##+##TacklingGamesWon##",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["TacklingGamesWon", "TacklingGamesSum"],
        calc: "##TacklingGamesWon##/((##TacklingGamesSum##)/100)",
      },
      {
        title: "gew. Zweikämpfe",
        key: "duelWon",
        sdKey: "TacklingGamesWon"
      },
      {
        title: "Fouls",
        key: "fouls",
        sdKey: "FoulsSum"
      },
    ],
  },
  playerCompareSeason: {
    midfielder: [
      {
        title: "Spiele",
        key: "Games Played",
        sdKey: "MatchesPlayedScouting"
      },
      {
        title: "Tore",
        key: "Goals",
        sdKey: "ShotsAtGoalSuccessfull"
      },
      // {
      //   title: "Torschüsse",
      //   key: "Shots On Target ( inc goals )",
      //   sdKey: "ShotsOnTarget"
      // },
      {
        title: "Assists",
        key: "Goal Assists",
        sdKey: "Assists"
      },
      // {
      //   title: "Torschussvorlagen",
      //   key: "Key Passes (Attempt Assists)",
      //   sdKey: "Chances"
      // },
      {
        title: "Ballaktionen",
        key: "Touches",
        sdKey: "BallActions"
      },
      // {
      //   title: "Pässe gesamt",
      //   key: "Total Passes",
      //   sdKey: "PassesSum"
      // },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["PassesSuccessfulSum", "PassesSum"],
        calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      },
      // {
      //   title: "Zweikampfquote in %",
      //   key: "calcZweikampfquote",
      //   deps: ["TacklingGamesLost", "TacklingGamesWon"],
      //   calc: "##TacklingGamesWon##/((##TacklingGamesLost##+##TacklingGamesWon##)/100)",
      // },
    ],
    striker: [
      {
        title: "Spiele",
        key: "Games Played",
        sdKey: "MatchesPlayedScouting"
      },
      {
        title: "Tore",
        key: "Goals",
        sdKey: "ShotsAtGoalSuccessfull"
      },
      {
        title: "Torschüsse",
        key: "Shots On Target ( inc goals )",
        sdKey: "ShotsOnTarget"
      },
      {
        title: "Torschussvorlagen",
        key: "Key Passes (Attempt Assists)",
        sdKey: "Chances"
      },
      {
        title: "Assists",
        key: "Goal Assists",
        sdKey: "Assists"
      },

      // {
      //   title: "Ballaktionen",
      //   key: "Touches",
      //   sdKey: "BallActions"
      // },
      // {
      //   title: "Pässe gesamt",
      //   key: "Total Passes",
      //   sdKey: "PassesSum"
      // },
      // {
      //   title: "Passquote in %",
      //   key: "calcPassquote",
      //   deps: ["PassesSuccessfulSum", "PassesSum"],
      //   calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      // },
      // {
      //   title: "Zweikampfquote in %",
      //   key: "calcZweikampfquote",
      //   deps: ["TacklingGamesLost", "TacklingGamesWon"],
      //   calc: "##TacklingGamesWon##/((##TacklingGamesLost##+##TacklingGamesWon##)/100)",
      // },
    ],
    defender: [
      {
        title: "Spiele",
        key: "Games Played",
        sdKey: "MatchesPlayedScouting"
      },
      {
        title: "Tore",
        key: "Goals",
        sdKey: "ShotsAtGoalSuccessfull"
      },
      // {
      //   title: "Torschüsse",
      //   key: "Shots On Target ( inc goals )",
      //   sdKey: "ShotsOnTarget"
      // },
      // {
      //   title: "Torschussvorlagen",
      //   key: "Key Passes (Attempt Assists)",
      //   sdKey: "Chances"
      // },
      // {
      //   title: "Pässe gesamt",
      //   key: "Total Passes",
      //   sdKey: "PassesSum"
      // },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["TacklingGamesLost", "TacklingGamesWon"],
        calc: "##TacklingGamesWon##/((##TacklingGamesLost##+##TacklingGamesWon##)/100)",
      },
      {
        title: "total fouls",
        key: "total fouls",
        sdKey: "FoulsSum"
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["PassesSuccessfulSum", "PassesSum"],
        calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      },
    ],
  },
  teamCompare: {
    offensive: [
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
        sdKey: "ShotsAtGoalSum"
      },
      {
        title: "Schüsse aufs Tor",
        key: "ontargetScoringAtt",
        sdKey: "ShotsOnTarget"
      },
      {
        title: "Big Chances",
        key: "bigChanceCreated",
        sdKey: "Chances"
      },
      {
        title: "Chancenverwertung in %",
        key: "calcChancesCreated",
        deps: ["GoalsScored", "ShotsAtGoalSum"],
        calc: "(##GoalsScored##/##ShotsAtGoalSum##)*100",
      },
      {
        title: "Ecken",
        key: "cornerTaken",
        sdKey: "CornerKicksSum"
      },
      // {
      //   title: "Erfolgreiche Dribblings in %",
      //   key: "calcSuccessContest",
      //   deps: ["DribblingsSuccessful", "DribblingsSum"],
      //   calc: "(##DribblingsSuccessful##/##DribblingsSum##)*100",
      // },
    ],
    defensive: [
      // {
      //   title: "Ballbesitz in %",
      //   key: "possessionPercentage",
      //   deps: ["PassesSum", "#VERSUS#PassesSum"],
      //   calc: "##PassesSum##/((##PassesSum##+#VERSUS#PassesSum##)/100)",
      // },
      {
        // title: "Zweikampfquote in %",
        // key: "calcZweikampfquote",
        title: "ShotAllowed",
        key: "ShotAllowed",
        deps: ["#VERSUS#ShotsAtGoalSum"],
        calc: "#VERSUS#ShotsAtGoalSum##",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["TacklingGamesLost", "TacklingGamesWon"],
        calc: "##TacklingGamesWon##/((##TacklingGamesLost##+##TacklingGamesWon##)/100)",
      },
      {
        title: "Fouls",
        key: "fkFoulLost",
        sdKey: "FoulsSum"
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
        sdKey: "PassesSum",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["PassesSuccessfulSum", "PassesSum"],
        calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      },
      // {
      //   title: "Anzahl Zweikämpfe",
      //   key: "calcZweikampfAnzahl",
      //   deps: ["TacklingGamesLost", "TacklingGamesWon"],
      //   calc: "##TacklingGamesLost##+##TacklingGamesWon##",
      // },

    ],
  },
  teamCompareSeason: {
    offensive: [
      {
        title: "Tore",
        key: "Goals",
        sdKey: "GoalsScored"
      },
      {
        title: "Torschüsse",
        key: "calcTotalShotsAndBlocked",
        sdKey: "ShotsAtGoalSum"
      },
      {
        title: "Schüsse aufs Tor",
        key: "Shots On Target ( inc goals )",
        sdKey: "ShotsOnTarget"
      },
      // {
      //   title: "Shooting Accuracy",
      //   key: "Shooting Accuracy",
      //   deps: ["ShotsOnTarget", "ShotsAtGoalSum"],
      //   calc: "##ShotsOnTarget##/(##ShotsAtGoalSum##/100)",
      // },
      {
        title: "Torschüsse",
        key: "chanceConversion",
        deps: ["ShotsAtGoalSum", "GoalsScored"],
        calc: "##GoalsScored##/(##ShotsAtGoalSum##)*100",
      },
      {
        title: "Shots within the box",
        key: "Shots within the box",
        sdKey: "ShotsAtGoalInsideBox"
      },
    ],
    defensive: [
      {
        title: "Zweikampfquote in %",
        key: "zweikampf", // Duels
        deps: ["TacklingGamesSum"],
        calc: "(##TacklingGamesSum##)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["TacklingGamesWon", "TacklingGamesSum"],
        calc: "##TacklingGamesWon##/((##TacklingGamesSum##)/100)",
      },
      // {
      //   title: "Ballbesitz in %",
      //   key: "possessionPercentage",
      //   deps: ["PassesSum", "#VERSUS#PassesSum"],
      //   // calc: "##PassesSum##/((##PassesSum##+#VERSUS#PassesSum##)/100)",
      //   calc: "##PassesSum##/((##PassesSum##+#VERSUS#PassesSum##)/100)",
      // },
      {
        title: "Passquote in %",
        key: "total passes",
        deps: ["PassesSum"],
        calc: "(##PassesSum##)",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["PassesSuccessfulSum", "PassesSum"],
        calc: "##PassesSuccessfulSum##/(##PassesSum##/100)",
      },
      {
        title: "total fouls",
        key: "total fouls",
        sdKey: "FoulsSum"
      },
    ],
  },
  teamGoalmouth: [
    {
      title: "Schüsse",
      key: "totalScoringAtt",
    },
    {
      title: "Torschüsse",
      key: "ontargetScoringAtt",
    },
    {
      title: "Tore",
      key: "goals",
    },
    {
      title: "Paraden %",
      key: "calcParaden",
      deps: ["ontargetScoringAtt", "#VERSUS#ontargetScoringAtt", "goalsConceded", "#VERSUS#goalsConceded"],
      // calc: "(#VERSUS#ontargetScoringAtt##-##goalsConceded##)/(#VERSUS#ontargetScoringAtt##)*100",
      calc: "(##ontargetScoringAtt##-#VERSUS#goalsConceded##)/(##ontargetScoringAtt##)*100",
      // calc: "#VERSUS#saves##/((##ontargetScoringAtt##)/100)",
    },
  ],
  ofTeamGoalmouth: [
    {
      title: "Schüsse",
      key: "totalScoringAtt",
    },
    {
      title: "Tore",
      key: "goals",
    },
    {
      title: "Paraden %",
      key: "calcParaden",
      deps: ["#VERSUS#saves", "ontargetScoringAtt"],
      calc: "#VERSUS#saves##/((##ontargetScoringAtt##)/100)",
    },
  ],
  playerHeatmap: [
    {
      title: "Ballaktionen",
      key: "touches",
    },
    {
      title: "Passquote in %",
      key: "calcPassquote",
      deps: ["accuratePass", "totalPass"],
      calc: "##accuratePass##/(##totalPass##/100)",
    },
    {
      title: "Pässe gesamt",
      key: "totalPass",
    },
  ],
};
